import './style.scss';

export function inner_block() {
  const block = document.querySelector('.inner_block');
  if (!block) return;
  
}
